import SpiderChart from './SpiderChart';
import { Legend } from './SpiderChart';

export default SpiderChart;
export { Legend };
